// sentry
import './instrument';

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/index.css';

// localization
import './i18n';

createRoot(document.getElementById('root')!).render(<App />);
